'use strict';

(function(angular) {

  var appModules = [
    'ngStorage',
    'angularLazyImg',
    'infinite-scroll',
  ];

  angular.module('ins.models', appModules).
      config(function($interpolateProvider, $locationProvider) {
        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');
        $locationProvider.html5Mode({
          enabled: true,
          requireBase: true,
          rewriteLinks: false,
        });
      }).
      config(function($httpProvider) {
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      }).config(function(lazyImgConfigProvider) {
    lazyImgConfigProvider.setOptions({
      successClass: 'in',
    });
  });

})(window.angular);